import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, IconButton, Link, Toolbar } from '@mui/material';
import React from 'react';
import AccountMenu from '../../AccountMenu';
import { useLayoutContext } from '../useLayoutContext';
import { SearchInput } from './SearchInput';
import { useWhiteLabelling } from 'hooks/useWhiteLabelling';

interface MainBarProps {
  width?: number;
}

const MainAppBar: React.FC<MainBarProps> = ({ width }) => {
  const { drawerVisible, drawerOpen, setDrawerOpen, appBarTools, printMode } = useLayoutContext();
  const whiteLabelling = useWhiteLabelling();
  if (printMode) return null;

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${width}px)` },
        ml: { sm: `${width}px` },
      }}
    >
      <Toolbar>
        {drawerVisible && (
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={() => setDrawerOpen(!drawerOpen)}
            sx={{ display: { lg: 'none' } }}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ px: 2, display: { xs: 'none', sm: 'flex', lg: 'none', cursor: 'pointer' } }}>
          <Link href="/" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <img src={whiteLabelling.logoLightUrl} alt={whiteLabelling.displayName} height={30} />
          </Link>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <SearchInput />
        </Box>
        {/* spacer */}
        <Box sx={{ flexGrow: 1 }} />

        {appBarTools}

        <AccountMenu />
      </Toolbar>
    </AppBar>
  );
};

export default MainAppBar;
